export default __webpack_public_path__ + "static/media/img3.cd7326e3.jpg";